import { ReminderType } from './types';

export const reminderTypeOptions = Object.values(ReminderType);

export const GoalWhiteList = Object.freeze([
  'name',
  'icon',
  'description',
  'endDate',
  'assigneeId',
  'assignerId',
  'slug',
  'parentId',
  'workspaceId',
  'privacy',
  'metricType',
  'metricCurrentValue',
  'metricGoalValue',
  'metricInitialValue',
]);
